import { render, staticRenderFns } from "./LandmarkList.vue?vue&type=template&id=261859f6&scoped=true"
import script from "./LandmarkList.vue?vue&type=script&lang=js"
export * from "./LandmarkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261859f6",
  null
  
)

export default component.exports